<template>
  <d-navbar-nav class="flex-row">
    <!-- <li class="nav-item border-right dropdown notifications">
      <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">2</d-badge>
        </div>
      </a>
      <d-collapse id="notifications" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item>
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE6E1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Analytics</span>
            <p>Your website’s active users count increased by <span class="text-success text-semibold">28%</span> in the last week. Great job!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item href="#">
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">&#xE8D1;</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Sales</span>
            <p>Last week your store’s sales count decreased by <span class="text-danger text-semibold">5.52%</span>. It could have been worse!</p>
          </div>
        </d-dropdown-item>
        <d-dropdown-item class="notification__all text-center">View all Notifications</d-dropdown-item>
      </d-collapse>
    </li>-->
    <li class="nav-item dropdown">
      <a class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions style="margin-top: 10px;">
        <!-- <img class="user-avatar rounded-circle mr-2" src="@/assets/images/avatars/0.jpg" alt="User Avatar"> 
        <span class="d-none d-md-inline-block">{{NavbarNav.User}}</span>  -->
        
        <span class="user-avatar rounded-circle mr-2" style="background-color:red;background-color: rgb(0, 123, 255); padding: 9px; padding-left: 11px; padding-right: 11px; color: white;font-weight: 500;font-size: 14px;" >{{NavbarNav.IconText}}</span>
        <span class="d-none d-md-inline-block">{{NavbarNav.User}}</span>


      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item>
          <div @click="Profile()">
            <i class="material-icons">&#xE7FD;</i> Profile
          </div>
        </d-dropdown-item>
        <d-dropdown-divider />
        <d-dropdown-item href="#" class="text-danger" >
          <div @click="Logout()">
            <i class="material-icons text-danger" >&#xE879;</i> Logout
            </div>
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import Utilities from '@/Utilities/Utilities';
export default {
    name: 'Title',
      data() {
        return {
            NavbarNav: {
              User:null,
              IconText:null,
            }
            }
            },
    mounted() {
      var FirstName=null;
      var LastName=null;

        FirstName=Utilities.GetSession('UserName');
        LastName="";
        this.NavbarNav.IconText = FirstName.substring(0, 1);
        this.NavbarNav.User= FirstName
    },
    methods: {
        Logout(){
          sessionStorage.removeItem('Token');
             this.$router.push({
                path: '/login'
            })
        },
        Profile()
        {
             this.$router.push({
                path: '/profile'
            })
        }

    },
};
</script>

<style>
  .nav-link:hover {
    cursor: pointer;
  }
</style>
